var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "card-dialog",
    {
      attrs: {
        title: _vm.$t("confirmation"),
        value: _vm.value,
        role: "dialog",
        "max-width": "500px",
      },
      on: {
        input: function (val) {
          return _vm.$emit("input", val)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                "dialog-action",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("input", false)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("no")))]
              ),
              _vm._v(" "),
              _c(
                "dialog-action",
                {
                  attrs: { disabled: !_vm.keeperEvent || _vm.merging },
                  on: { click: _vm.merge },
                },
                [_vm._v(_vm._s(_vm.$t("yes")))]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.keeperEvent
        ? _c(
            "div",
            [
              _vm.hasDifferentTrapNo
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mb-3 body-2",
                      attrs: { type: "warning", dense: "" },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("merge.different_trap_no")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.confirmMessage) },
              }),
            ],
            1
          )
        : _c("div", [
            _vm._v("\n    " + _vm._s(_vm.$t("merge.select_two")) + "\n  "),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }